import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { BUTTON_TYPES } from '../../../base/ui/constants.web';
import { HangupContextMenuItem } from './HangupContextMenuItem';
// @ts-ignore
import UIEvents from "../../../../../service/UI/UIEvents";
// @ts-ignore
import { isLocalParticipantModerator } from "../../../base/participants";
/**
 * Button to leave the conference.
 *
 * @param {Object} props - Component's props.
 * @returns {JSX.Element} - The leave conference button.
 */
export const LeaveConferenceButton = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const _isLocalParticipantModerator = useSelector(isLocalParticipantModerator);
    const onLeaveConference = useCallback(() => {
        sendAnalytics(createToolbarEvent('hangup'));
        APP.UI.emitEvent(UIEvents.LOGOUT);
        // if (_isLocalParticipantModerator){
        //     APP.store.dispatch(openLogoutDialog(
        //         () => APP.UI.emitEvent(UIEvents.LOGOUT)
        //     ));
        // } else {
        //     dispatch(leaveConference());
        // }
    }, [dispatch]);
    return (React.createElement(HangupContextMenuItem, { accessibilityLabel: t('toolbar.accessibilityLabel.leaveConference'), buttonKey: props.buttonKey, buttonType: BUTTON_TYPES.SECONDARY, label: t('toolbar.leaveConference'), notifyMode: props.notifyMode, onClick: onLeaveConference }));
};
